import CategoryPicker from '@aspendental/shared-components-web/lib/components/CategoryPicker';
import { ICategoryPickerProps } from '@aspendental/shared-components-web/lib/components/CategoryPicker/CategoryPicker';
import { Suspense } from 'react';
type TCategoryPicker = ICategoryPickerProps & {
  __typename: string;
};
export type ContentItem = TCategoryPicker;
interface IComponentResolverProps {
  contentItem: ContentItem;
}
const componentMap = {
  CategoryPicker: CategoryPicker
};
export default function ComponentResolver({
  contentItem
}: IComponentResolverProps) {
  if (!contentItem?.__typename) {
    return null;
  }
  if (!componentMap[contentItem?.__typename]) {
    return null;
  }
  const ContentComponent = componentMap[contentItem?.__typename];
  return <Suspense data-sentry-element="Suspense" data-sentry-component="ComponentResolver" data-sentry-source-file="ComponentResolver.tsx">
			<ContentComponent {...contentItem} data-sentry-element="ContentComponent" data-sentry-source-file="ComponentResolver.tsx" />
		</Suspense>;
}